<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :loading="loading"
        @change="onChange"
      >

        <template slot="name" slot-scope="name">
          <span>{{name}}</span>
        </template>
        <template slot="email" slot-scope="email">
          <span>{{email}}</span>
        </template>
        <template slot="phone" slot-scope="phone">
          <span class="font-weight-bold">{{phone}}</span>
        </template>
        <template slot="children" slot-scope="children">
          <span class="font-weight-bold">{{children.length}}</span>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- view -->
            <a-tooltip
              placement="top"
              title="View"
            >
              <a href="javascript:" class="btn btn-sm btn-success mr-2" @click="showViewModal(record)">
                <i class="fe fe-eye" />
              </a>
            </a-tooltip>
            <!-- Edit -->
<!--            <a-tooltip
              placement="top"
              title="Edit Registered Parent"
            >
              <a href="javascript:" class="btn btn-sm btn-light mr-2" @click="showEditModal(record)">
                <i class="btn-addon-icon fe fe-edit" />
              </a>
            </a-tooltip>-->
            <!-- Delete -->
<!--            <a-tooltip
              placement="top"
              title="Delete"
            >
              <a href="javascript:" class="btn btn-sm btn-danger" @click="onDelete(record)">
                <i class="btn-addon-icon fe fe-trash" />
              </a>
            </a-tooltip>-->
          </div>
        </template>
      </a-table>
    </div>

    <edit-student ref="editStudent" :session="session" @edited="handleTableUpdate"/>
    <registered-parent-details></registered-parent-details>
  </div>
</template>

<style>
.ant-table-row-expand-icon {
  display: none !important;
}
</style>

<script>

import moment from 'moment'
import EditStudent from '@/components/student/Forms/Edit/index'
import RegisteredParentDetails from '@/components/appregistration/parentregistration/Forms/single/index'

const columns = [
  {
    title: 'Name',
    className: 'text-left text-gray-6',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: 'Email',
    className: 'text-left',
    dataIndex: 'email',
    scopedSlots: { customRender: 'email' },
    sorter: (a, b) => a.email.localeCompare(b.email),
  },
  {
    title: 'Phone No',
    dataIndex: 'phone',
    scopedSlots: { customRender: 'phone' },
    sorter: (a, b) => a.phone - b.phone,
  },
  {
    title: 'No. of Child',
    dataIndex: 'children',
    scopedSlots: { customRender: 'children' },
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]
function onChange(sorter) {
  console.log('params', sorter)
}

export default {
  name: 'RegisteredParentTable',
  components: {
    EditStudent,
    RegisteredParentDetails,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    session: Number,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
      expandedRowKeys: [],
    }
  },
  watch: {
    // whenever question changes, this function will run
    loading: function () {
      this.selectedRowKeys = []
    },
  },
  methods: {
    onChange,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.$emit('selectChange', selectedRowKeys)
    },
    showViewModal: function(record) {
      this.$eventBus.$emit('openViewRegisteredParentDetailsModal', record)
    },
    /* handleEditClickFromView(studentId) {
      // this.$refs.editStudent.showModal(studentId)
      this.$eventBus.$emit('openStudentEditModal', studentId)
    },
    showEditModal: function(record) {
      // this.$refs.editStudent.showModal(record.id)
      this.$eventBus.$emit('openStudentEditModal', record.id)
    }, */
    handleTableUpdate: function () {
      this.$emit('updateTable')
    },
    handleDate: function($date) {
      return moment($date).format('DD-MM-YYYY')
    },
    onDelete: function(record) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Clicking Yes will delete ${record.first_name} ${record.last_name}?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/student/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.first_name + ' ' + record.last_name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
